import React, { Component } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import theme from '../../../theme';
import Grid from '@material-ui/core/Grid';
import Input from '../../../reusableComponents/input';
import { AddCircle } from '@material-ui/icons';
import { Delete } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';
import BioProgress from '../BioProgress';
import { MixPanelKey } from 'environmentVariables';

var mixpanel = require('mixpanel-browser');
mixpanel.init(MixPanelKey);

const InfoSection = styled.div`
    border-radius: 6px;
    background-color: #f7f7f7;
    margin: 10px;
    padding: 10px;
    color: ${theme.palette.primary.main};
`;

const Category = styled.div`
    margin: 0px;
`;

const CategoryTitle = styled.p`
    color: ${theme.palette.primary.main};
    font-size: 12;
    font-weight: bold;
    margin-left: 20px;
    margin-top: 15px;
`;

const CategoryInfo = styled.div`
    background-color: #ffffff;
    border-radius: 6px;
    font-size: 12px;
    font-weight: regular;
    margin-top: 15px;
    margin-bottom: 15px;
    margin-left: 18px;
    margin-right: 18px;
`;

const CategorySeparator = styled.hr`
    width: 95%;
    size: 4;
    color: #f7f7f7;
    margin-top: 25px;
    margin-bottom: 10px;
`;

export default class FamilyEditDisplay extends Component {
    onChangeTextKids = async (id, type, value) => {
        const { kids, setKids } = this.props;
        for (let i = 0; i < kids.length; i++) {
            if (kids[i].id === id) {
                let kids_copy = [...kids];
                let kid = { ...kids_copy[i] };
                if (type === 'name') {
                    kid.name = value;
                } else if (type === 'parsed_birthday') {
                    kid.parsedBirthday = value;
                    kid.birthday = value;
                } else if (type === 'comments') {
                    kid.comments = value;
                }
                kids_copy[i] = kid;
                setKids({ kids: kids_copy });
            }
        }
    };

    addKid(type) {
        const { kids, setKids, addKidsIndex, kidsIndex } = this.props;

        addKidsIndex();

        const addedKid = {
            id: kidsIndex,
            isBirthday: true,
            isName: true,
            name: '',
            birthday: '',
            comments: '',
            newKid: true,
            type: type,
        };

        setKids({
            kids: [...kids, addedKid],
            newKid: true,
        });
    }

    deleteKid(id) {
        const { kids, deletedKids, setKids } = this.props;
        const newArray = [...kids];

        newArray.splice(
            newArray.findIndex((ele) => ele.id === id),
            1,
        );

        setKids({ kids: newArray, deletedKids: [...deletedKids, id] });
    }

    editCategory(type, dependents) {
        const { kids } = this.props;
        return (
            <CategoryInfo>
                <Grid item xs={11} justify="center" style={{ paddingTop: 20 }}>
                    {dependents.length > 0 &&
                        dependents.map((dependent, i) => (
                            <div>
                                <Grid container justify="space-between" item key={i}>
                                    <Grid item xs={kids.length > 1 ? 10 : 11}>
                                        <Input
                                            fullWidth
                                            error={!dependent.isName}
                                            helperText={
                                                !dependent.isName
                                                    ? dependent.type === 'Child'
                                                        ? "Please enter your child's name"
                                                        : "Please enter your pet's name"
                                                    : ''
                                            }
                                            type="text"
                                            id={dependent.name}
                                            variant="outlined"
                                            value={dependent.name}
                                            label="Name"
                                            onChange={(e) =>
                                                this.onChangeTextKids(dependent.id, 'name', e.target.value)
                                            }
                                            style={{
                                                backgroundColor: '#ffffff',
                                                marginLeft: 17,
                                                marginRight: 17,
                                                color: theme.palette.primary.main,
                                            }}
                                        />
                                    </Grid>
                                    {kids.length > 1 && (
                                        <Grid item xs={1}>
                                            <Delete
                                                onClick={() => this.deleteKid(dependent.id)}
                                                style={{ verticalAlign: 'center', marginTop: 12 }}
                                            />
                                        </Grid>
                                    )}
                                </Grid>

                                <Grid container item>
                                    <Input
                                        fullWidth
                                        error={!dependent.isBirthday}
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        helperText={!dependent.isBirthday ? 'MM/DD/YYYY' : ''}
                                        id={dependent.parsedBirthday}
                                        variant="outlined"
                                        label={dependent.name
                                            .charAt(0)
                                            .toUpperCase()
                                            .concat(dependent.name.slice(1))
                                            .concat("'s Birthday")}
                                        value={dependent.birthday}
                                        onChange={(e) =>
                                            this.onChangeTextKids(dependent.id, 'parsed_birthday', e.target.value)
                                        }
                                        style={{
                                            backgroundColor: '#ffffff',
                                            marginLeft: 17,
                                            marginRight: 17,
                                        }}
                                    />
                                </Grid>
                                <Grid container item>
                                    <Input
                                        fullWidth
                                        id={dependent.comments}
                                        variant="outlined"
                                        value={dependent.comments}
                                        onChange={(e) =>
                                            this.onChangeTextKids(dependent.id, 'comments', e.target.value)
                                        }
                                        label={
                                            'Comments for ' +
                                            dependent.name.charAt(0).toUpperCase() +
                                            dependent.name.slice(1)
                                        }
                                        style={{
                                            backgroundColor: '#ffffff',
                                            marginLeft: 17,
                                            marginRight: 17,
                                        }}
                                    />
                                </Grid>
                            </div>
                        ))}
                </Grid>
                <Grid item xs={11} sm={11}>
                    <AddCircle
                        onClick={() => this.addKid(type)}
                        style={{
                            marginLeft: 17,
                            marginBottom: 20,
                            color: theme.palette.primary.main,
                        }}
                    />
                </Grid>
            </CategoryInfo>
        );
    }

    render() {
        const { isBio, bio, kids, onChangeText, validate } = this.props;
        var children = kids.filter((kid) => kid.type.toLowerCase() === 'child');
        var pets = kids.filter((kid) => kid.type.toLowerCase() === 'pet');

        return (
            <div>
                <Grid container justify="center" alignItems="center">
                    <Grid item justify="center" alignItems="center" sm={6} xs={12}>
                        <InfoSection style={{ minWidth: '90%', marginBottom: '20%' }}>
                            <Category style={{ justifyContent: 'center' }}>
                                <CategoryTitle>Edit Bio</CategoryTitle>
                                <CategoryInfo>
                                    <Grid item xs={11} sm={11} justify="center" style={{ paddingTop: 20 }}>
                                        <Input
                                            fullWidth
                                            error={!isBio}
                                            helperText={
                                                !isBio ? 'Please enter a bio' : '(This will be shown to sitters.)'
                                            }
                                            id="bio"
                                            label="Tell us about your family!"
                                            variant="outlined"
                                            value={bio}
                                            onChange={(e) => onChangeText('bio', e)}
                                            style={{ backgroundColor: '#ffffff', marginLeft: 17, marginRight: 17 }}
                                            multiline
                                            rows="6"
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={11}
                                        justify="center"
                                        style={{
                                            marginLeft: 10,
                                            marginRight: 10,
                                            paddingBottom: 20,
                                            height: isMobile ? '12vh' : '9vh',
                                        }}
                                    >
                                        <BioProgress bio={bio} />
                                    </Grid>
                                </CategoryInfo>
                                <CategorySeparator />
                                <CategoryTitle>Edit Kids </CategoryTitle>
                                {this.editCategory('Child', children)}
                                <CategoryTitle>Edit Pets </CategoryTitle>
                                {this.editCategory('Pet', pets)}
                                <Grid item xs={11} sm={11}>
                                    <Button
                                        onClick={() => {
                                            validate();
                                            mixpanel.track('Profile: Edit Family save button pressed', {
                                                bio: bio,
                                                kids: kids,
                                            });
                                        }}
                                        style={{
                                            marginLeft: 17,
                                            color: '#ffffff',
                                            backgroundColor: theme.palette.primary.main,
                                        }}
                                    >
                                        Save
                                    </Button>
                                </Grid>
                            </Category>
                        </InfoSection>
                    </Grid>
                </Grid>
            </div>
        );
    }
}
